// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Rana backend API
 * The API service for Rana.
 *
 * The version of the OpenAPI document: v1-alpha
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { SignedSubscription } from "./SignedSubscription";
import {
  SignedSubscriptionFromJSON,
  SignedSubscriptionFromJSONTyped,
  SignedSubscriptionToJSON,
  SignedSubscriptionToJSONTyped,
} from "./SignedSubscription";

/**
 *
 * @export
 * @interface SubscriptionRequest
 */
export interface SubscriptionRequest {
  /**
   *
   */
  givenName: string;
  /**
   *
   */
  familyName: string;
  /**
   *
   */
  email: string;
  /**
   *
   */
  subscription: SignedSubscription;
}

/**
 * Check if a given object implements the SubscriptionRequest interface.
 */
export function instanceOfSubscriptionRequest(value: object): value is SubscriptionRequest {
  if (
    (!("givenName" in (value as Record<string, any>)) &&
      !("given_name" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["givenName"] === undefined &&
      (value as Record<string, any>)["given_name"] === undefined)
  )
    return false;
  if (
    (!("familyName" in (value as Record<string, any>)) &&
      !("family_name" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["familyName"] === undefined &&
      (value as Record<string, any>)["family_name"] === undefined)
  )
    return false;
  if (!("email" in value) || value["email"] === undefined) return false;
  if (!("subscription" in value) || value["subscription"] === undefined) return false;
  return true;
}

export function SubscriptionRequestFromJSON(json: any): SubscriptionRequest {
  return SubscriptionRequestFromJSONTyped(json, false);
}

export function SubscriptionRequestFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): SubscriptionRequest {
  if (json == null) {
    return json;
  }
  return {
    givenName: json["given_name"],
    familyName: json["family_name"],
    email: json["email"],
    subscription: SignedSubscriptionFromJSON(json["subscription"]),
  };
}

export function SubscriptionRequestToJSON(json: any): SubscriptionRequest {
  return SubscriptionRequestToJSONTyped(json, false);
}

export function SubscriptionRequestToJSONTyped(
  value?: SubscriptionRequest | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    given_name: value["givenName"],
    family_name: value["familyName"],
    email: value["email"],
    subscription: SignedSubscriptionToJSON(value["subscription"]),
  };
}
